import "../../App.css";

const Button = ({
    className,
    onClick = () => { },
    buttonText = "Proceed",
    disabled,
    style = {}
}) => {

    return (
        <button className={className}
            onClick={onClick}
            disabled={disabled}
            style={{
                color: disabled ? "#000" : "#fff",
                cursor: disabled ? "default" : "pointer",
                backgroundColor: disabled ? "#e2e8f0" : "#0a1a4f",
                boxShadow: disabled ? "none" : "0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1))",
                ...style
            }}
        >
            {buttonText}
        </button>
    );
};

export default Button;